<template>
  <a-tooltip :title="i18nRender('layouts.switch', [i18nRender('layouts.new.version')])">
    <a class="right-content__action" @click="visible = true">
      <icon-font type="gb-icon-switch-circle" />
      <!-- modal -->
      <a-modal v-model="visible" :title="i18nRender('version-modal.title')" :width="620" dialogClass="version-change-modal">
        <div class="tips">
          <icon-font type="gb-icon-tishi" />
          <span>{{ i18nRender('version-modal.tips') }}，</span>
          <a href="" class="color">URL <icon-font style="margin-left: 5px" type="gb-icon-fenxiang_2"></icon-font></a>
        </div>
        {{ i18nRender('version-modal.info') }}<br>
        1. {{ i18nRender('version-modal.subInfo-1') }}<br>
        2. {{ i18nRender('version-modal.subInfo-2') }}<br>
        3. {{ i18nRender('version-modal.subInfo-3') }}
        <a-row slot="footer" type="flex" justify="space-between">
          <a-checkbox v-model="agreeToSwitchFlag" style="float:left;">
            {{ i18nRender('version-modal.footer') }}
            <a-button class="color" type="link" style="padding: 0" @click="toDemo">{{ i18nRender('version-modal.viewDemo') }}</a-button>
          </a-checkbox>
          <a-col>
            <a-button @click="visible = false" >{{ i18nRender('form-modal.cancel') }}</a-button>
            <a-button type="primary" @click="handleOk" :loading="submitLoading" :disabled="!agreeToSwitchFlag">{{ i18nRender('form-modal.submit') }}</a-button>
          </a-col>
        </a-row>
      </a-modal>
    </a>
  </a-tooltip>
</template>

<script>
import { i18nRender } from '@/locales'
import { switchDemo } from '@/api/sso/subjectService'
import { updatePlatformCode } from '@/api/sso/role'

export default {
  data () {
    return {
      visible: false,
      agreeToSwitchFlag: false,
      submitLoading: false
    }
  },
  methods: {
    i18nRender,
    handleOk () {
      this.submitLoading = true
      updatePlatformCode({
        updatePlatformCode: 'SSO_SYS_USER_SUPER'
      }).then(() => {
        window.location.reload(false)
      }).catch(() => {
        this.submitLoading = false
      })
    },
    toDemo () {
      switchDemo({
        demoEnvironment: 'FLAGSHIP'
      }).then(({ data }) => {
        if (data) {
          window.open(`//${data.url}/entry/${data.serviceId}/ERP?token=${data.token}`)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@color: rgba(87, 170, 255, 1);

.color {
  color: @color
}

/deep/.version-change-modal {
  .ant-modal-content .ant-modal-body {
    padding: 0px 18px 15px 18px;
    position: relative;
    font-size: 14px;
    line-height:24px
  }
}

.tips {
  position: relative;
  margin-left: -18px;
  margin-right: -18px;
  background: #E7F7FF;
  border-radius: 0 0 2px 2px;
  border: 1px solid #CAE9FF;
  border-top: none;
  padding: 6px 17px;
  font-size: 12px;
  line-height:20px;
  margin-bottom: 15px;
  .color;
  * {
    display: inline;
    word-break: break-all;
  }
  .anticon {
    font-size: 14px;
    margin-right: 5px;
  }
}

button:hover {
  opacity: 0.8;
}
</style>
